const useGetQueryParam = () => {
  const storedParams = sessionStorage.getItem("utmParams");
  return storedParams ? JSON.parse(storedParams) : {};
};

export default useGetQueryParam;
